import React from "react";

import { useMutation } from "@apollo/client";
import { useParams, useNavigate } from "react-router-dom";

import { graphql } from "@/gql";
import useGlobalSnackbar from "@/hooks/useGlobalSnackbar";
import useRecordEventOnLoad from "@/hooks/useRecordEventOnLoad";
import { formatISODate } from "@/utils/datetime";
import { displayError } from "@/utils/errors";

import ProgramForm from "../components/ProgramForm";
import ProgramDetailsForm, {
  ProgramDetailsFormProps,
} from "../components/ProgramForm/ProgramDetailsForm";

const createProgramMutation = graphql(`
  mutation CreateProgram($input: CreateProgramInput!) {
    createProgram(input: $input) {
      program {
        id
        name
        description
        startDate
        endDate
        client {
          id
          status
        }
      }
    }
  }
`);

const NewPlanPage: React.FC = () => {
  useRecordEventOnLoad("create_meal_plan_attempt");
  const navigate = useNavigate();
  const { clientId } = useParams<{ clientId: string }>();
  const snackbar = useGlobalSnackbar();
  const [createProgram] = useMutation(createProgramMutation);

  const handleDetailsSubmit: ProgramDetailsFormProps["onSubmit"] = (values) => {
    return createProgram({
      variables: {
        input: {
          attributes: {
            clientId: clientId,
            name: values.name,
            description: values.description,
            startDate: formatISODate(values.startDate),
            endDate: formatISODate(values.endDate),
          },
        },
      },
    })
      .then((result) => {
        if (result.data?.createProgram?.program) {
          const { id } = result.data.createProgram.program;
          snackbar.open("Program created successfully");
          navigate(`../${id}/edit`, { replace: true });
        }
      })
      .catch((e) => {
        snackbar.open(displayError(e, "Unable to create program"));
      });
  };

  return (
    <ProgramForm
      backTo={".."}
      hasDetails={false}
      renderProgramDetails={() => (
        <ProgramDetailsForm onSubmit={handleDetailsSubmit} />
      )}
      renderMealPlan={() => null}
    />
  );
};

export default NewPlanPage;
